/**
 * Copyright © Ircam Amplify 2026
 */

import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'

interface LayoutState {
  sideBarCollapsed: boolean
  moduleSelectorCurrentPageId: number
  failedPdfUrls: Record<string, boolean>
}

const initialState: LayoutState = {
  sideBarCollapsed: false,
  moduleSelectorCurrentPageId: 0,
  failedPdfUrls: {},
}

export const LayoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setSideBarCollapsed: (
      state: Draft<typeof initialState>,
      action: PayloadAction<typeof initialState.sideBarCollapsed>
    ) => {
      state.sideBarCollapsed = action.payload
    },
    setModuleSelectorCurrentPageId: (
      state: Draft<typeof initialState>,
      action: PayloadAction<typeof initialState.moduleSelectorCurrentPageId>
    ) => {
      state.moduleSelectorCurrentPageId = action.payload
    },
    setPdfLoadFailed: (
      state: Draft<typeof initialState>,
      action: PayloadAction<string>
    ) => {
      state.failedPdfUrls[action.payload] = true
    },
    resetLayoutSlice: () => initialState,
  },
})

export const getLayoutState = (state: { layout: LayoutState }) => state.layout
export const {
  setSideBarCollapsed,
  setModuleSelectorCurrentPageId,
  setPdfLoadFailed,
  resetLayoutSlice,
} = LayoutSlice.actions
export default LayoutSlice.reducer
